import { useId } from 'react';
import { joinClasses } from 'utils/componentStyles/style.utils';
import WeatherCardGrid from 'features/Weather/components/WeatherCardGrid/WeatherCardGrid';

const MarineConditionPanel = ({
  title,
  dateLabel,
  isRefreshing,
  marineData = [],
  details = [],
  emptyMessage = 'No marine condition data available.',
  getCardKey = (entry, index) =>
    [entry?.iso8601, entry?.day_segment, index].filter(Boolean).join('-'),
  getCardTitle = (entry) => entry?.day_segment ?? 'Marine Conditions',
  getCardSubtitle,
  getCardIcon,
  containerClassName,
  headerClassName,
  titleClassName,
  statusClassName,
  cardListClassName,
  cardContainerClassName,
  hasPanelChrome = true,
  headingLevel: Heading = 'h2',
  cardHeadingLevel = 'h3',
}) => {
  const headingId = useId(); // Generate a unique ID for the heading element that can be used across rerenders

  return (
    <section
      aria-labelledby={headingId}
      className={joinClasses(
        'd-flex w-100 flex-column text-white',
        hasPanelChrome && 'h-100 rounded-3 bg-base p-3',
        containerClassName,
      )}
    >
      <div
        className={joinClasses(
          'd-flex align-items-start justify-content-between gap-3',
          headerClassName,
        )}
      >
        <div className="min-w-0">
          <Heading id={headingId} className={joinClasses('m-0 fs-4 fw-bold lh-sm', titleClassName)}>
            {title}
          </Heading>
          {dateLabel && <p className="m-0 mt-1 small text-secondary">{dateLabel}</p>}
        </div>

        {isRefreshing && (
          <span className={joinClasses('small text-secondary', statusClassName)} role="status">
            Updating...
          </span>
        )}
      </div>
      <WeatherCardGrid
        entries={marineData}
        details={details}
        emptyMessage={emptyMessage}
        getCardKey={getCardKey}
        getCardTitle={getCardTitle}
        getCardSubtitle={getCardSubtitle}
        getCardIcon={getCardIcon}
        containerClassName={cardListClassName}
        cardContainerClassName={cardContainerClassName}
        cardHeadingLevel={cardHeadingLevel}
      />
    </section>
  );
};

export default MarineConditionPanel;
